var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',[_c('EditOptionsModal',{ref:"modal"}),_c('Hoverlay',{attrs:{"data-cy":"form-item-edit-options-btn"},on:{"click":_vm.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }